import React, { useState } from "react";
import Popup from "reactjs-popup";
import ReactHtmlParser from "react-html-parser";

import List from "./List";

import "./style.css";
import "reactjs-popup/dist/index.css";
import useSearch from "./useSearch";

const contentStyle = {
  maxWidth: "815px",
  width: "100%",
  padding: "0px",
  border: "unset",
};

const VideoPopup = ({ video_links, popup_btn_text }) => {
  const [currentVideo, setCurrentVideo] = useState({
    url: "",
    title: "",
    id: "",
  });

  const [searchShow, setSearchShow] = useState(true);

  const { results, searchValue, setSearchValue } = useSearch({
    dataSet: video_links,
    keys: [["title"]],
  });

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };
  const handleVideoChange = (index, items) => {
    if (items) {
      setCurrentVideo({
        url: items[index]?.url,
        id: index,
        title: items[index]?.title,
      });
      setSearchShow(false);
    } else {
      setCurrentVideo({
        url: results[index]?.url,
        id: index,
        title: results[index]?.title,
      });
      setSearchShow(false);
    }
  };

  return (
    <Popup
      trigger={
        <button type="button" className="popup-btn">
          {popup_btn_text}
        </button>
      }
      modal
      lockScroll={true}
      contentStyle={contentStyle}
      nested
    >
      {(close) => (
        <div className="modal-omt">
          <button className="close" onClick={close}>
            &times;
          </button>

          <div className="content">
            <div className="search-outerwrap">
              {searchShow && (
                <>
                  <input
                    className="search-box"
                    type="text"
                    value={searchValue}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                  />
                </>
              )}
            </div>

            <List
              searchShow={searchShow}
              filteredVideos={results}
              currentVideo={currentVideo}
              handleVideoChange={handleVideoChange}
            />

            {currentVideo?.url && (
              <div>
                <div
                  className="backBtn"
                  onClick={() => {
                    setCurrentVideo({ url: "", title: "", id: "" });
                    setSearchShow(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                    />
                  </svg>
                </div>
                <p
                  style={{ minWidth: "100%", textAlign: "center" }}
                  className="popup-title"
                >
                  {ReactHtmlParser(currentVideo?.title)}
                </p>
                {currentVideo?.url ? ReactHtmlParser(currentVideo?.url) : null}
              </div>
            )}
          </div>
        </div>
      )}
    </Popup>
  );
};

export default VideoPopup;
